import "core-js/modules/es.object.define-property";
import { __assign } from "tslib";

var LayoutsStore =
/** @class */
function () {
  function LayoutsStore() {}

  Object.defineProperty(LayoutsStore.prototype, "layout", {
    get: function get() {
      return this._layout;
    },
    set: function set(_layout) {
      this._layout = __assign({}, _layout);
    },
    enumerable: false,
    configurable: true
  });
  return LayoutsStore;
}();

export default new LayoutsStore();